import { Form } from '@form/Form';
import FormConsumser from '@form/FormConsumer';
import FormInput from '@form/FormInput';
import { Spacer } from '@ui';
import { EventSummary } from 'components/EventCalendar/Event/EventSummary';
import { Event } from 'components/EventCalendar/types';
import useFetchFields from 'components/Formular/hooks/useFetchFields';
import Loader from 'components/Loader';
import Joi from 'joi';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import useSWR from 'swr';
import { useApi } from '../../../../hooks/useApi';
import FormFields from '../../../Formular/FormFields';

interface Props {
    clubSlug: string;
    eventId?: number;
    callback?: (data: any) => any;
}

export const ManualBookingForm: React.FunctionComponent<React.PropsWithChildren<React.PropsWithChildren<Props>>> = ({ clubSlug, eventId, callback }) => {
    const api = useApi();
    const { t } = useTranslation('bookings');
    const [isLoading, setIsLoading] = useState(false);
    const { data, isLoading: dataIsLoading } = useSWR<{ data: Event }>(`event/${eventId}`);
    const event = data?.data;
    const {
        fields,
        validationSchema: formValidationSchema,
        isLoading: formIsLoading
    }: { [x: string]: any } = useFetchFields(event?.form_id);
    const isLoadingData = dataIsLoading || formIsLoading;

    const handleSubmit = (data) => {
        setIsLoading(true);
        return api({
            url: `booking/${event?.id}/manual`,
            method: 'POST',
            data,
            onBefore: () => setIsLoading(false),
            onSuccess: ({ data }) => callback?.(data)
        });
    };

    const validationSchema = Joi.object({
        name: Joi.string().required().label(t('booking.manual.nameLabel')),
        email: Joi.string().email({ tlds: false }).required().label(t('booking.manual.emailLabel')),
        connect_user: Joi.boolean().label(t('booking.manual.connectUserAccount')),
        form_data: formValidationSchema
    });

    return (
        <Loader isLoading={isLoadingData}>
            <Form onSubmit={handleSubmit} validationSchema={validationSchema}>
                <FormConsumser>
                    {({ watch }) => {
                        const email = watch('email');
                        return <EventSummary event={event} email={email} />;
                    }}
                </FormConsumser>

                <Spacer y={1} />
                <FormInput name="name" label={t('booking.manual.nameLabel')} />
                <FormInput name="email" label={t('booking.manual.emailLabel')} />
                <FormInput.Checkbox spacing={6} name="connect_user">
                    {t('booking.manual.connectUserAccountCheckbox')}
                </FormInput.Checkbox>
                <FormFields namePrefix="form_data" fields={fields} withoutLegal />
                <FormInput.Submit isLoading={isLoading}>{t('booking.manual.submit')}</FormInput.Submit>
            </Form>
        </Loader>
    );
};
